import React from 'react'
import styles from "./logo.module.css"
import { FaFeather } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

const LogoItem = ({theme = "light",skeleton = false}) => {
    const navigate = useNavigate()
    
    return (
        <div className = {`${styles.appRep} ${theme === "dark" ? styles.dark : ""} ${skeleton ? styles.skeleton : ""}`}>
            <div className={styles.appIcon} onClick={() => navigate("/")}>
                <FaFeather className={styles.featherShadow}/>
                <FaFeather className={styles.featherMain}/>
            </div>
            <div className={styles.appName}>
                <span className={styles.appNameAccent}>N</span>ote
                <span className={styles.appNamePro}>Pro</span>
            </div>
        </div>
    )
}

export default LogoItem